// eslint-disable-next-line max-len
const validateURLRegExp = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/;

export const validateURLString = urlString => validateURLRegExp.test(urlString);

export const getLastSegmentOfUrlHref = url => url.split('/').filter(Boolean).pop();

export const getArticleIdFromUrl = url => {
  const urlMatches = url.match(/\d{1,}/);

  if (urlMatches) {
    return urlMatches[0];
  }

  return null;
};
